import React, { memo } from 'react'
import { Link } from 'react-router-dom'
import { InlineMessage, INLINE_MESSAGE_VARIANTS } from 'transfix-ui/components/InlineMessage'
import { IStop } from 'types'
import { IReloadsCategory } from 'types/reloads'

interface IReloadsFilterLinkProps {
  category: IReloadsCategory
  stop: IStop
  type: 'load' | 'reload'
}

const makeUrlParams = (ids: number[]) =>
  decodeURI(JSON.stringify({ filters: { ids }, pageCount: 0 }))

export const ReloadsFilterLink = memo<IReloadsFilterLinkProps>(
  ({ category: { error, ids, radius }, stop, type }) => {
    return (
      <div className='pb2'>
        <InlineMessage
          type={error ? INLINE_MESSAGE_VARIANTS.ALERT : INLINE_MESSAGE_VARIANTS.INFO}
          message={
            error || (
              <>
                <Link to={`/?query=${makeUrlParams(ids)}`} target='_blank'>
                  {ids.length} {type}
                  {ids.length === 1 ? '' : 's'}
                </Link>
                &nbsp;{type === 'load' ? 'picking up' : ''} near {stop.city}, {stop.state} (+
                {radius}mi)
              </>
            )
          }
        />
      </div>
    )
  }
)
